import React, { useState, useRef } from "react"
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import AccountMenu from '../components/AccountMenu';


const theme = createTheme();

const KENLIFY_BUTTON_TEXT = 'KENLIFY';
const COPY_BUTTON_TEXT = 'COPY';
const COPIED_BUTTON_TEXT = 'COPIED!';

export default function Form() {

    const [inputText, setInputText] = useState('');
    const [submitButtonText, setSubmitButtonText] = useState(KENLIFY_BUTTON_TEXT);
    const [submitButtonActive, setSubmitButtonActive] = useState(true);

    function onFormSubmit(event) {
        event.preventDefault();
    }

    function onClick(event) {

        if (submitButtonActive) {
            postForm();
        } else {
            copyToClipboard();
            setSubmitButtonText(COPIED_BUTTON_TEXT);

            setTimeout(() => {
                setSubmitButtonText(COPY_BUTTON_TEXT);
            }, 1000);
        }
    }

    const cleanUrl = () => {
        let newUrl = inputText;

        if (!inputText.startsWith('http')) {
            newUrl = 'http://' + inputText;
        }

        return newUrl;
    }

    const copyToClipboard = () => {
        unsecuredCopyToClipboard(inputText);
    }

    function unsecuredCopyToClipboard(text) {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
            document.execCommand('copy');
        } catch (err) {
            console.error('Unable to copy to clipboard', err);
        }
        document.body.removeChild(textArea);
    }

    async function postForm() {
        const postUrl = '/kenlify';

        const data = {
            url: cleanUrl(inputText),
            authenticity_token: document.querySelector('[name=csrf-token]').content
        };

        const headers = new Headers();
        headers.append('Content-Type', 'application/json; charset=utf-8');

        const options = {
            method: 'POST',
            body: JSON.stringify(data),
            headers: headers
        }

        try {
            const response = await fetch(postUrl, options);
            const obj = await response.json();
    
            console.log(obj);

            if (obj.errors) {
                alert(obj.errors);
                return;
            }

            setInputText(window.location.origin + '/kenlified/' + obj.redirect);
            setSubmitButtonText(COPY_BUTTON_TEXT);
            setSubmitButtonActive(false);

        } catch (error) {
            const errorMessage = error + ' There is an error. Please try again later.'
            alert(errorMessage);
            console.error(errorMessage);
        }
    }

    const onInputChange = (event) => {
        setInputText(event.target.value);
        setSubmitButtonText(KENLIFY_BUTTON_TEXT);
        setSubmitButtonActive(true);
    }

    return (
        <ThemeProvider theme={theme}>
            <Container component="main" maxWidth="sm">
                <CssBaseline />
                    <AccountMenu />
                    <Box 
                        component="form"
                        onSubmit={onFormSubmit}
                        sx={{ 
                            mt: 8,
                            alignItems: 'center'
                        }}
                    >
                        <Grid container spacing={2}>
                            <Grid item xs={8} sm={10}>
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="url"
                                    label="URL"
                                    name="url"
                                    value={inputText}
                                    onChange={onInputChange} 
                                    autoFocus
                                />
                            </Grid>
                            <Grid item xs={3} sm={2}>
                                <Button
                                    type='submit'
                                    onClick={onClick}
                                    variant="contained"
                                    size="large"
                                    sx={{
                                        mt: 2,
                                        minWidth: 110,
                                        minHeight: 55
                                    }}
                                >
                                    {submitButtonText}
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
            </Container>
        </ThemeProvider>
    )
  };